<span class="fa fa-asterisk text-danger small-asterisk"></span>